import React, { useState, useEffect } from "react";
import image2 from "../../Assets/dos_donts.png";
import "./SafetySection.css";

const SafetySection = () => {
  const [activeTab, setActiveTab] = useState("dos");
  const [animatedItems, setAnimatedItems] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const dosItems = [
    { icon: "fas fa-store", text: "Buy from licensed dealers only", color: "#10b981" },
    { icon: "fas fa-fire-extinguisher", text: "Keep safety equipment ready", color: "#f59e0b" },
    { icon: "fas fa-water", text: "Discard used fireworks in water", color: "#3b82f6" },
    { icon: "fas fa-user-shield", text: "Adult supervision for children", color: "#8b5cf6" },
    { icon: "fas fa-book-open", text: "Read and follow instructions", color: "#ec4899" },
  ];

  const dontsItems = [
    { icon: "fas fa-child", text: "Don't let children play alone", color: "#ef4444" },
    { icon: "fas fa-tshirt", text: "Avoid synthetic/loose clothing", color: "#f97316" },
    { icon: "fas fa-hand-paper", text: "Never hold crackers in hand", color: "#dc2626" },
    { icon: "fas fa-fire", text: "Keep away from open flames", color: "#eab308" },
    { icon: "fas fa-users-slash", text: "Avoid crowded areas", color: "#7c3aed" },
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Staggered animation on mount & tab change
  useEffect(() => {
    setAnimatedItems([]);
    const items = activeTab === "dos" ? dosItems : dontsItems;
    items.forEach((_, index) => {
      setTimeout(() => {
        setAnimatedItems(prev => [...prev, index]);
      }, index * 150);
    });
  }, [activeTab]);

  const currentItems = activeTab === "dos" ? dosItems : dontsItems;

  return (
    <div className="safsec fade-in-up">
      {/* Background pattern */}
      <div className="safsec-bg">
        <div className="safsec-bg-grid"></div>
        <div className="safsec-bg-orb safsec-bg-orb--1"></div>
        <div className="safsec-bg-orb safsec-bg-orb--2"></div>
      </div>

      <div className="safsec-container">
        {/* Header */}
        <div className="safsec-header">
          <div className="safsec-header-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
            </svg>
            Safety First
          </div>
          <h2 className="safsec-title">
            Celebrate <span className="safsec-title-highlight">Responsibly</span>
          </h2>
          <p className="safsec-subtitle">
            Essential guidelines for a safe and joyful celebration
          </p>
        </div>

        {/* Main content */}
        <div className="safsec-content">
          {/* Left - Interactive Cards */}
          <div className="safsec-cardszone">
            {/* Desktop: side by side, Mobile: tabbed */}
            {!isMobile ? (
              <div className="safsec-dualcards">
                {/* Do's Column */}
                <div className="safsec-col">
                  <div className="safsec-colheader safsec-colheader--dos">
                    <span className="safsec-colicon">
                      <i className="fas fa-check-circle"></i>
                    </span>
                    <span>DO'S</span>
                  </div>
                  <div className="safsec-items">
                    {dosItems.map((item, idx) => (
                      <div 
                        key={idx} 
                        className="safsec-item safsec-item--dos"
                        style={{ 
                          animationDelay: `${idx * 0.12}s`,
                          borderLeftColor: item.color 
                        }}
                      >
                        <span className="safsec-itemicon" style={{ background: `${item.color}15`, color: item.color }}>
                          <i className={item.icon}></i>
                        </span>
                        <span>{item.text}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* VS Divider */}
                <div className="safsec-vs">
                  <div className="safsec-vsbox">
                    <span>VS</span>
                  </div>
                </div>

                {/* Don'ts Column */}
                <div className="safsec-col">
                  <div className="safsec-colheader safsec-colheader--donts">
                    <span className="safsec-colicon">
                      <i className="fas fa-times-circle"></i>
                    </span>
                    <span>DON'TS</span>
                  </div>
                  <div className="safsec-items">
                    {dontsItems.map((item, idx) => (
                      <div 
                        key={idx} 
                        className="safsec-item safsec-item--donts"
                        style={{ 
                          animationDelay: `${idx * 0.12}s`,
                          borderLeftColor: item.color 
                        }}
                      >
                        <span className="safsec-itemicon" style={{ background: `${item.color}15`, color: item.color }}>
                          <i className={item.icon}></i>
                        </span>
                        <span>{item.text}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              /* Mobile: Tabbed view */
              <div className="safsec-mobiletabs">
                <div className="safsec-tabbtns">
                  <button 
                    className={`safsec-tabbtn ${activeTab === "dos" ? "safsec-tabbtn--active safsec-tabbtn--dos" : ""}`}
                    onClick={() => setActiveTab("dos")}
                  >
                    <i className="fas fa-check-circle"></i> Do's
                  </button>
                  <button 
                    className={`safsec-tabbtn ${activeTab === "donts" ? "safsec-tabbtn--active safsec-tabbtn--donts" : ""}`}
                    onClick={() => setActiveTab("donts")}
                  >
                    <i className="fas fa-times-circle"></i> Don'ts
                  </button>
                </div>

                <div className="safsec-mobileitems">
                  {currentItems.map((item, idx) => (
                    <div 
                      key={idx} 
                      className={`safsec-item safsec-item--${activeTab === "dos" ? "dos" : "donts"} ${animatedItems.includes(idx) ? "safsec-item--visible" : ""}`}
                      style={{ 
                        borderLeftColor: item.color,
                        transitionDelay: `${idx * 0.1}s`
                      }}
                    >
                      <span className="safsec-itemicon" style={{ background: `${item.color}15`, color: item.color }}>
                        <i className={item.icon}></i>
                      </span>
                      <span>{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Right - Image with overlay */}
          <div className="safsec-imagezone">
            <div className="safsec-imagewrap">
              <div className="safsec-imageframe">
                <img src={image2} alt="Safety Guidelines" className="safsec-image" />
              </div>
              {/* Rotating ring */}
              <div className="safsec-ring">
                <svg viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="48" fill="none" stroke="currentColor" strokeWidth="1" strokeDasharray="8 4"/>
                </svg>
              </div>
            </div>
            <div className="safsec-imagecaption">
              <i className="fas fa-shield-alt"></i>
              <span>Your Safety Matters</span>
            </div>
          </div>
        </div>

        {/* Bottom notice */}
        <div className="safsec-footer">
          <div className="safsec-footerbar">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
            </svg>
            <span>Celebrate with joy, not with risk. Follow safety guidelines for a memorable festival.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafetySection;